import axios from "axios";
import {API_URL} from "../../../utils/apiURLs";

// items => filtered/sorted result
export function findOrders(params) {
  return axios.get(`${API_URL.ORDER_LIST}`, { params });
}

// READ
export function getOrderById(orderId) {
  return axios.get(`${API_URL.ORDER_LIST}/${orderId}`);
}
